import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const product = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("products"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("products/" + id));
    return data;
  },
  // CATATAN: argumennya POSISIONAL. Menambah field baru berarti menambah parameter
  // di sini DAN di setiap pemanggilnya — kalau salah satu terlewat, field-nya tidak
  // terkirim dan backend memakai default kolom tanpa gejala apa pun. Itulah yang
  // terjadi pada `is_unique_barcode`: form sudah punya pilihannya, tapi nilainya
  // berhenti di modal.
  store: async (
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    colors,
    sizes,
    imageUrl,
    is_unique_barcode
  ) => {
    const { data } = await axios.post(h.baseUrl("products"), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      colors,
      sizes,
      imageUrl,
      is_unique_barcode,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl,
    is_unique_barcode
  ) => {
    const { data } = await axios.put(h.baseUrl("products/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      is_unique_barcode,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("products/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default product;
